/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete a child node.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class DeleteNodeCommand<T extends Node> extends AbstractCommand {
    public _property : string;

    public _parentPath : NodePath;

    public _oldValue : any;

    public constructor(property? : any, from? : any) {
        if(((typeof property === 'string') || property === null) && ((from != null && from instanceof <any>Node) || from === null)) {
            let __args = arguments;
            super();
            if(this._property===undefined) this._property = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._property===undefined) this._property = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldValue===undefined) this._oldValue = null;
            (() => {
                this._property = property;
                this._parentPath = Library.createNodePath(from);
            })();
        } else if(property === undefined && from === undefined) {
            let __args = arguments;
            super();
            if(this._property===undefined) this._property = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._property===undefined) this._property = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldValue===undefined) this._oldValue = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[" + this.type() + "] Executing.");
        let parent : Node = this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let propertyNode : T = <T><any>NodeCompat.getProperty(parent, this._property);
        if(this.isNullOrUndefined(propertyNode)) {
            this._oldValue = null;
            return;
        } else {
            this._oldValue = Library.writeNode(propertyNode);
        }
        NodeCompat.setProperty(parent, this._property, null);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[" + this.type() + "] Reverting.");
        let parent : Node = this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent) || this.isNullOrUndefined(this._oldValue)) {
            return;
        }
        let restoredNode : T = this.readNode(document, this._oldValue);
        restoredNode._parent = parent;
        restoredNode._ownerDocument = parent.ownerDocument();
        NodeCompat.setProperty(parent, this._property, restoredNode);
    }

    abstract readNode(doc : Document, node : any) : T;
}
DeleteNodeCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteNodeCommand";
DeleteNodeCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




